<template>
  <div class="progress-container" :style="{ height: height + 'px' }">
    <div
      class="progress-percentage"
      :style="{ width: progressPercentage + '%' }"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'GStepperProgress',
  props: {
    progressPercentage: {
      type: Number,
      default: 0,
    },
    height: {
      type: [Number, String],
      default: 7,
    },
  },
});
</script>
<style lang="scss" scoped>
.progress-container {
  @apply w-full bg-grey-50 relative rounded-full;

  .progress-percentage {
    @apply absolute rounded-full bg-everBlue-500 h-full transition-all duration-500 ease-in-out;
  }
}
</style>
